export const mediaServicesInfo = `Order photography, videography, floor plans, Matterport, drone media, and more.`;
export const editingServicesAgent = `Order editing services to upgrade an image, remove objects, virtually stage, and more.`;
export const editingServicesTechnician = `Order Fusion photo editing (bracketed sets), virtual twilight, floor plan upgrades, virtual staging, and more.`;
